import React, { useState } from "react";
import img4 from "./assets/images/img4.png";
import img5 from "./assets/images/img5.png";
import img7 from "./assets/images/img7.png";
import img8 from "./assets/images/img8.png";
import img9 from "./assets/images/img9.png";
import img10 from "./assets/images/img10.png";
import img11 from "./assets/images/img11.png";
import img12 from "./assets/images/img12.png";
import img16 from "./assets/images/img16.png";
import img24 from "./assets/images/img24.png";
import img32 from "./assets/images/img32.png";
import img33 from "./assets/images/img33.jpg";
import img34 from "./assets/images/img34.png";
import img35 from "./assets/images/img35.png";
import img36 from "./assets/images/img36.png";
import img37 from "./assets/images/img37.png";
import img38 from "./assets/images/img38.png";
import img39 from "./assets/images/img39.jpg";
import img40 from "./assets/images/img40.jpg";
import img41 from "./assets/images/img41.png";
import img42 from "./assets/images/img42.jpg";
import img43 from "./assets/images/img43.png";
import img44 from "./assets/images/img44.png";
import img45 from "./assets/images/img45.png";
import img46 from "./assets/images/img46.png";
import img25 from "./assets/images/img25.png";
import img26 from "./assets/images/img26.png";
import img27 from "./assets/images/img27.png";
import img28 from "./assets/images/img28.png";
import img29 from "./assets/images/img29.png";
import img30 from "./assets/images/img30.png";
import img31 from "./assets/images/img31.png";
import BildeBoks from "./components/BildeBoks";
import NavigasjonsKnapper from "./components/Navigasjonsknapper";
import "./bytt-passord.less";

const macPages = [
  {
    bilde: [],
    beskrivelse: (
      <div className="modal__description">
        <h1>Logg inn på laptopen</h1>
        <p>
          Brukernavnet ditt i Bekk er{" "}
          <b>fornavn.etternavn@bekk.no</b>
        </p>
        <p>Brukernavnet lokalt på Mac er <b>fornavn</b>.</p>
        <p>
          Passordet ditt er <b>skuret12W!</b> Dette skal vi bytte.
        </p>
      </div>
    ),
  },
  {
    bilde: [],
    beskrivelse: (
      <div className="modal__description">
        <h1>Oppsett av Microsoft Authenticator</h1>
        <p>På din mobil: hent appen Authenticator fra Microsoft.</p>
        <p>
          Har du allerede Authenticator med en gammel konto fra Bekk, fjern
          denne kontoen før du går videre.
        </p>
      </div>
    ),
  },
  {
    bilde: [img32],
    beskrivelse: (
      <div className="modal__description">
        <h1>Microsoft Authenticator del 1</h1>
        <p>I Authenticator: trykk på + øverst i høyre hjørne.</p>
      </div>
    ),
  },
  {
    bilde: [img33],
    beskrivelse: (
      <div className="modal__description">
        <h1>Microsoft Authenticator del 2</h1>
        <p>Velg Jobb eller skolekonto.</p>
      </div>
    ),
  },
  {
    bilde: [img34],
    beskrivelse: (
      <div className="modal__description">
        <h1>Microsoft Authenticator del 3</h1>
        <p>Skriv inn ditt brukernavn og velg Neste.</p>
      </div>
    ),
  },
  {
    bilde: [img35],
    beskrivelse: (
      <div className="modal__description">
        <h1>Microsoft Authenticator del 4</h1>
        <p>
          Angi midlertidig tilgangspass (TAP) som du har fått utdelt og fullfør.
        </p>
      </div>
    ),
  },
  {
    bilde: [],
    beskrivelse: (
      <div className="modal__description">
        <h1>Bytt passord lokalt</h1>
        <p>
          Passordet må være minst 16 tegn og inneholde store og små bokstaver
          samt tall og/eller tegn.
        </p>
          <p>Trykk "NESTE →" for hvordan.</p>
      </div>
    ),
  },
  {
    bilde: [img36],
    beskrivelse: (
      <div className="modal__description">
        <h1>Åpne System Settings</h1>
          <p>Trykk på tannhjul-ikonet.</p>
      </div>
    ),
  },
  {
    bilde: [img37],
    beskrivelse: (
      <div className="modal__description">
        <h1>Users &amp; Groups</h1>
        <p>
          Gå til Users &amp; Groups og trykk på i-ikonet til venstre for
          brukernavnet ditt.
        </p>
      </div>
    ),
  },
  {
    bilde: [img38],
    beskrivelse: (
      <div className="modal__description">
        <h1>Bytt passord lokalt</h1>
        <p>Trykk på Change-knappen og bytt passordet.</p>
      </div>
    ),
  },
  {
    bilde: [img39, img40],
    beskrivelse: (
      <div className="modal__description">
        <h1>Bytte passord i Entra</h1>
        <p>
          <b>NB!</b> Før du går videre, ta kontakt med Thomas eller Eivind.
        </p>
      </div>
    ),
  },
  {
    bilde: [img41],
    beskrivelse: (
      <div className="modal__description">
        <h1>Åpne Company Portal</h1>
        <p>Åpne Company Portal og logg inn. Skriv inn brukernavnet ditt.</p>
      </div>
    ),
  },
  {
    bilde: [img42],
    beskrivelse: (
      <div className="modal__description">
        <h1>QR-kode</h1>
        <p>Trykk Next og velg QR-kode.</p>
        <p>Scan QR med mobil, åpne link og godkjenn med Authenticator.</p>
      </div>
    ),
  },
  {
    bilde: [img43],
    beskrivelse: (
      <div className="modal__description">
        <h1>Bytt passord del 1</h1>
        <p>
          Trykk på ikonet oppe til høyre med dine initialer.
        </p>
      </div>
    ),
  },
  {
    bilde: [img44],
    beskrivelse: (
      <div className="modal__description">
        <h1>Bytt passord del 2</h1>
        <p>Trykk på Change password.</p>
      </div>
    ),
  },
  {
    bilde: [img45],
    beskrivelse: (
      <div className="modal__description">
        <h1>Bytt passord del 3</h1>
        <p>Trykk Next.</p>
      </div>
    ),
  },
  {
    bilde: [img42],
    beskrivelse: (
      <div className="modal__description">
        <h1>Bytt passord del 4</h1>
        <p>Scan QR med mobil, åpne link og godkjenn med Authenticator.</p>
      </div>
    ),
  },
  {
    bilde: [img46],
    beskrivelse: (
      <div className="modal__description">
        <h1>Bytt passord del 5</h1>
        <p>Bytt passordet ditt.</p>
      </div>
    ),
  },
  {
    bilde: [],
    beskrivelse: (
      <div className="modal__description">
        <h1>Passordoppsettet er fullført!</h1>
      </div>
    ),
  },
];

const pcPages = [
  {
    bilde: [img24],
    beskrivelse: (
      <div className="modal__description">
        <h1>Logg inn</h1>
        <p>
          Passordet er <b>skuret12W!</b>
        </p>
      </div>
    ),
  },
  {
    bilde: [img25],
    beskrivelse: (
      <div className="modal__description">
        <h1>Sett opp Windows Hello</h1>
        <p>
          Velg "Yes, set up" hvis du vil sette opp Face ID eller "Skip for now"
          hvis du ikke ønsker dette.
        </p>
      </div>
    ),
  },
  {
    bilde: [img26],
    beskrivelse: (
      <div className="modal__description">
        <h1>Trykk "Create pin"</h1>
      </div>
    ),
  },
  {
    bilde: [img4],
    beskrivelse: (
      <div className="modal__description">
        <h1>Trykk "Next"</h1>
      </div>
    ),
  },
  {
    bilde: [img5],
    beskrivelse: (
      <div className="modal__description">
        <h1>Microsoft Authenticator del 1</h1>
        <p>
          Last ned Microsoft Authenticator appen på mobilen din og trykk "Next".
        </p>
      </div>
    ),
  },
  {
    bilde: [img7, img8, img9],
    beskrivelse: (
      <div className="modal__description">
        <h1>Microsoft Authenticator del 2</h1>

        <p>Åpne appen og trykk på + oppe i høyre hjørne.</p>
        <p>Velg "Jobb- eller skolekonto" og "Scan QR-kode".</p>
        <p>Scan QR-koden fra laptopen med mobilen din.</p>
      </div>
    ),
  },
  {
    bilde: [img10, img11, img12],
    beskrivelse: (
      <div className="modal__description">
        <h1>Microsoft Authenticator del 3</h1>
        <p>Skriv inn nummeret i appen og svar "Ja"</p>
        <p>Trykk "Next"</p>
      </div>
    ),
  },
  {
    bilde: [img28, img29],
    beskrivelse: (
      <div className="modal__description">
        <h1>Microsoft Authenticator del 4</h1>

        <p>Skriv inn "AuthPassord"</p>
        <p>Trykk "Next"</p>
        <p>
          Du trenger ikke å lagre passordet som genereres. Helpdesk vil hjelpe
          deg med å lage nytt passord hvis du skulle havne i en situasjon hvor
          det er nødvendig.
        </p>
        <p>Trykk "Done"</p>
      </div>
    ),
  },
  {
    bilde: [img30],
    beskrivelse: (
      <div className="modal__description">
        <h1>Microsoft Authenticator del 5</h1>
        <p>Trykk "Done".</p>
      </div>
    ),
  },
  {
    bilde: [img27],
    beskrivelse: (
      <div className="modal__description">
        <h1>Endre PIN</h1>

        <p>Velg "Include letters and symbols"</p>
        <p>
          Opprett et nytt, personlig passord. Dette må inneholde minst 16 tegn
          og kan ikke inneholde æ, ø og å. Vi anbefaler at dette passordet er
          det samme som du ønsker å bruke på Office365-kontoen din, slik at du
          ikke må huske to passord.
        </p>
        <p>Gå videre.</p>
      </div>
    ),
  },
  {
    bilde: [img16],
    beskrivelse: (
      <div className="modal__description">
        <h1>Endre passord</h1>

        <p>Trykk ctrl+alt+del</p>
        <p>Velg "Change a password"</p>
        <p>Trykk på din e-postkonto</p>
        <p>
          Skriv inn <b>skuret12W!</b> under "Old password"
        </p>
        <p>
          Opprett et nytt, personlig passord. Dette må inneholde minst 16 tegn
          og kan ikke inneholde æ, ø og å. Vi anbefaler at dette passordet er
          det samme som det du opprettet i forrige steg.
        </p>
      </div>
    ),
  },
  {
    bilde: [img31],
    beskrivelse: (
      <div className="modal__description">
        <p>
          Steng nettleservinduet og ta deg en fem-minutters pause mens passordet
          ditt blir synkronisert.
        </p>
      </div>
    ),
  },
  {
    bilde: [],
    beskrivelse: (
      <div className="modal__description">
        <h1>Passordoppsettet er fullført!</h1>
        <p>
          Prøv å logge ut og deretter inn igjen med ditt nye passord for å
          kontrollere at det nye passordet ditt funker som det skal.
        </p>
      </div>
    ),
  },
];

const ByttPassord = ({ setIsOpen }) => {
  const [device, choseDevice] = useState();
  const [count, setCount] = useState(0);

  switch (device) {
    case "LENOVO":
      return (
        <div id="byttPassord">
          <div className="scrollview">
            <div id="byttPassordInnhold">
              <BildeBoks images={pcPages[count].bilde} />
              {pcPages[count].beskrivelse}
            </div>
          </div>

          <NavigasjonsKnapper
            limit={pcPages.length}
            current={count}
            backward={() => {
              setCount(count - 1);
            }}
            forward={() => {
              setCount(count + 1);
            }}
            zeroAction={() => {
              choseDevice(null);
            }}
            endAction={() => {
              setIsOpen(false);
            }}
          />
        </div>
      );
    case "MAC":
      return (
        <div id="byttPassord">
          <div className="scrollview">
            <div id="byttPassordInnhold">
              <BildeBoks images={macPages[count].bilde} />
              {macPages[count].beskrivelse}
            </div>
          </div>
          <NavigasjonsKnapper
            limit={macPages.length}
            current={count}
            backward={() => {
              setCount(count - 1);
            }}
            forward={() => {
              setCount(count + 1);
            }}
            zeroAction={() => {
              choseDevice(null);
            }}
            endAction={() => {
              setIsOpen(false);
            }}
          />
        </div>
      );
    default:
      return (
        <div id="byttPassordVelger">
          <h1>Hvilken type laptop har du?</h1>
          <div style={{ display: "flex" }}>
            <button
              className="modal__laptop-brand-button"
              onClick={() => choseDevice("LENOVO")}
            >
              LENOVO
            </button>
            <button
              className="modal__laptop-brand-button"
              onClick={() => choseDevice("MAC")}
            >
              MAC
            </button>
          </div>
        </div>
      );
  }
};

export default ByttPassord;
